module.exports = __webpack_public_path__ + "img/ring_y_i_null_1@3x.b621a55e.png";